import { render, staticRenderFns } from "./EditEditorialList.vue?vue&type=template&id=786d952a"
import script from "./EditEditorialList.vue?vue&type=script&lang=js"
export * from "./EditEditorialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports